import { LocaleWrapper } from '@empiriecom/module-components/IntlProvider';
import deDE from './de-DE.json';
import deCH from './de-CH.json';
import frCH from './fr-CH.json';

const messages: LocaleWrapper = {
  'de-DE': deDE,
  'de-CH': deCH,
  'fr-CH': frCH,
};

export default messages;
